import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IFilterExDate } from '../../../../../core/filters/ex-date.filter';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
interface IPageAc0033 {
    multiOccurrence: IMultiOccurrence;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrencePtaOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
}
/* @ngInject */
export default function As0003Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    exDateFilter: IFilterExDate,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    Pagination: IPaginationClass,
    $stateParams: IStateParamsService,
    $state: IStateService,
    notificationHandler: INotificationHandler,
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemAction: IMenuItemActionClass,
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    rc0001Route: IRoute
) {
    const vm: IPageAc0033 = this;
    vm.valeursEcran = ecranDetails.valeurs;

    const actionsRec = [
        new MenuItemForage(
            'LBL_BTN_TXM',
            rc0001Route.NAME,
            (rowData: any) => ({
                id: rowData.doccleint
            }),
            {
                fonction: 'BOUTXM',
                icon: 'exit_to_app',
                iconButton: true
            }
        )
    ];
    vm.multiOccurrencePtaOptions = {
        bloc: 'rci',
        fonctions: {
            pagination: true,
            editionRapide: true
        },
        editionRapideActive: true,
        modeEditionRapide: true,
        pagination: new Pagination({
            nombreElementPage: 30,
            nbElementsPossibles: [30, 60]
        }),
        colonnesVisibles: [
            { nom: 'dailig', largeur: 120 },
            { nom: 'dainumcat', largeur: 150 },
            { nom: 'daidsc', largeur: 250 },
            { nom: 'dahqtecmd', largeur: 126 },
            { nom: 'dahqterec', largeur: 126 },
            { nom: 'rciqte', largeur: 126 },
            { nom: 'rcicom', largeur: 400 }
        ], colonnesEditionRapide: [
            { nom: 'dailig', largeur: 120 },
            { nom: 'dainumcat', largeur: 150 },
            { nom: 'daidsc', largeur: 250 },
            { nom: 'dahqtecmd', largeur: 126 },
            { nom: 'dahqterec', largeur: 126 },
            { nom: 'rciqte', largeur: 126 },
            { nom: 'rcicom', largeur: 400 }
        ],
        colonnesCachees: ['daicleint'],
        formulaire: new Formulaire([
            new FormulaireItem('dailig'),
            new FormulaireItem('dainumcat'),
            new FormulaireItem('daidsc'),
            new FormulaireItem('dahqtecmd'),
            new FormulaireItem('dahqterec'),
            new FormulaireItem('rciqte', {
                readonly: (data: any) => (data.$ancetre.etat !== '0010'),
            }),
            new FormulaireItem('rcicom', {
                readonly: (data: any) => (data.$ancetre.etat !== '0010'),
            })
        ], { largeurDefaut: 33.33 })
    };
    vm.multiOccurrenceOptions = {
        criteresSuggeres: new Formulaire([
            new FormulaireItem('doccleintref', {
                default: $stateParams.doccleintref,
                required: true,
                readonly: true
            })
        ]),
        actionsNouveaux: new Menu([
            new MenuItemAction(
                'NVL_RECEPTION',
                'NVLRECEP',
                () => ({}),
                {
                    icon: 'add_circle',
                    fonction: 'BTN_AFFCMD',
                    formulaireConfirmationAction: {
                        lblTitre: 'NVL_RECEPTION',
                        lblConfirm: '',
                        largeurFormulaire: 30,
                        formulaire: new Formulaire([
                            new FormulaireItem('dhrdatrecep', {
                                default: nowYmdHms,
                                required: true, largeur: 50
                            }),
                            new FormulaireItem('usrcodcre', { readonly: true, default: vm.valeursEcran.usrcodcre }),
                            new FormulaireItem('doccleintref', { readonly: true }),
                            new FormulaireItem('tydcleint', { readonly: true, default: vm.valeursEcran.tydcleint }),
                            new FormulaireItem('dhrnumcon', {
                                required: true,
                                maxlength: 25
                            }),
                            new FormulaireItem('dhrdsc', {
                                required: true,
                                default: vm.valeursEcran.dhrdsc
                            }),
                            new FormulaireItem('dhrnomtra'),
                            new FormulaireItem('dhrnumemb'),
                            new FormulaireItem('dhrnbrcolrec'),
                            new FormulaireItem('dhrnbrcolliv')
                        ], { largeurDefaut: 100 })
                    },
                    successAction: (response) => {
                        response.reponse && notificationHandler.erreur({
                            lblMessage: response.reponse
                        });
                    },

                    disabled: $stateParams.histo
                }
            )
        ]),
        fonctions: {
            rechercheCollapsable: false,
            effaceCriteres: true,
            suiviModification: false,
            selectionCycle: true
        },
        colonnesFixesGauche: [
            { nom: 'txmdat', largeur: 160 },
            { nom: 'usrcodcre', largeur: 140 },
            { nom: 'dacnumdoc', largeur: 120 },
            { nom: 'tydcoddac', largeur: 100 }
        ],
        colonnesVisibles: [
            { nom: 'txmnumdoc', largeur: 130 },
            { nom: 'tydcodtxm', largeur: 100 },
            { nom: 'etddsc', largeur: 140 },
            { nom: 'txmnumref', largeur: 140 },
            { nom: 'txmdsc', largeur: 200, menu: actionsRec },
            { nom: 'txmnomtra', largeur: 200 },
            { nom: 'txmnumemb', largeur: 140 },
            { nom: 'txmnbrcolrec', largeur: 120 },
            { nom: 'txmnbrcolliv', largeur: 120 }
        ],colonnesCachees:['etat'],
        multiOccurrenceOptionsEnfant: vm.multiOccurrencePtaOptions
    };
    function nowYmdHms() {
        const d = new Date();
        const pad = (n: any) => String(n).padStart(2, '0');
        return (
            d.getFullYear() + '-' +
            pad(d.getMonth() + 1) + '-' +
            pad(d.getDate()) + ' ' +
            pad(d.getHours()) + ':' +
            pad(d.getMinutes()) + ':' +
            pad(d.getSeconds())
        );
    }
}
